export default class NewsFiltersBar {
    constructor() {
        this.settings = {
            el: document.querySelector('[data-block="news-archive"]'),
        };
        this.bindUIActions();
    }
    bindUIActions() {
        if (this.settings.el) {
            const filtersButton = document.querySelector(".js-news-filters-btn");
            const filtersBar = document.querySelector(".js-news-filters-bar");
            const filtersBarClose = document.querySelector(".js-news-filters-bar-close");
            const filtersAccBtn = document.querySelectorAll(".js-news-filters-accordion-button");

            filtersButton.addEventListener("click", () => {
                filtersBar.classList.toggle("open");
            });

            if(filtersBarClose) {
                filtersBarClose.addEventListener("click", () => {
                    filtersBar.classList.toggle("open");
                });
            }

            filtersAccBtn.forEach((button) => {
                button.addEventListener("click", () => {
                    const panel = button.nextElementSibling;
                    const arrow = button.querySelector("i");
                    
                    if (panel.style.maxHeight) {
                        panel.style.maxHeight = null;
                        arrow.classList.remove("transform");
                        arrow.classList.remove("rotate-180");
                    } else {
                        panel.style.maxHeight = panel.scrollHeight + "px";
                        arrow.classList.add("transform");
                        arrow.classList.add("rotate-180");
                    }
                });
            });
        }
    }
}
new NewsFiltersBar();